import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AuthShell } from '@/components/auth-layout';

export const Route = createFileRoute('/_auth')({
  component: AuthRouteLayout,
});

function AuthRouteLayout() {
  return (
    <AuthShell>
      <Outlet />
    </AuthShell>
  );
}
